















































































import Vue from "vue";
import InfoLine from "@/components/Cluster/StatusLine.vue";
import InfoCard from "@/components/Cluster/StatusCard.vue";
import { mapState, mapGetters, mapActions } from "vuex";

import { Header } from "../../MyTable.vue";
import { uuid } from "../../../utils/uuid";

const tableHeader: Header[] = [
  { title: "名称", width: 200 },
  { title: "主机", width: 200 },
  { title: "容器组IP", width: 180 },
  { title: "状态信息", width: 200 },
  { title: "标签", minWidth: 300 },
  { title: "注解", minWidth: 300 },
  { title: "创建时间", width: 180 }
];

export default Vue.extend({
  name: "Container",
  components: { InfoLine, InfoCard },
  props: {
    hostData: { type: Object }
  },
  data() {
    return {
      tableHeader,
      container: uuid(),
      disabled: false,
      start: new Date(new Date().getTime() - 60 * 60 * 1000 * 2),
      end: new Date()
    };
  },
  computed: {
    ...mapState("HostMonitor/Container", [
      "total",
      "hasNext",
      "pageNum",
      "loading"
    ]),
    ...mapGetters("HostMonitor/Container", ["tableData"])
  },
  mounted() {
    this.getCard();
    this.getTable();
    (this.$refs.line as any).getData();
  },
  beforeDestroy() {
    this.clear();
  },
  methods: {
    ...mapActions("HostMonitor/Container", ["getData", "pageTurn", "clear"]),

    getTable() {
      this.getData({
        url: `/monitor/hosts/${this.hostData.name}/pods`
      });
    },
    getCard() {
      (this.$refs.card as any).getData();
    },
    turnPage(page: number) {
      this.disabled = true;
      this.pageTurn({ page }).finally(() => {
        this.disabled = false;
      });
    }
  }
});
